module.exports = __webpack_public_path__ + "static/pokoj-nr6-photo02-9359196fb3aff5986287d75790f5a1af.jpg";